module.exports = __webpack_public_path__ + "img/Patch11-1.b92023ce.webp";